import {
  ARABIC_DECIMAL_SEPARATOR_PATTERN,
  ARABIC_INDIC_ZERO_CODE,
  ARABIC_THOUSANDS_SEPARATOR_PATTERN,
  EASTERN_DIGIT_PATTERN,
  EXTENDED_ARABIC_INDIC_ZERO_CODE,
} from "../constants/number";

// NOTE: NSAI-4570 — a leaf module so `date.ts` (the chat timestamp) and
// `number.ts` (`formatNumber`) share one fallback without importing each other.
const toWesternDigit = (digit: string): string => {
  const code = digit.charCodeAt(0);
  const zeroCode =
    code >= EXTENDED_ARABIC_INDIC_ZERO_CODE
      ? EXTENDED_ARABIC_INDIC_ZERO_CODE
      : ARABIC_INDIC_ZERO_CODE;
  return String(code - zeroCode);
};

// HACK: Some engines (older Hermes / ICU builds) ignore both `-u-nu-latn` and the
// `numberingSystem` option, so the output is mapped back as well.
export const toWesternDigits = (value: string): string =>
  value
    .replace(EASTERN_DIGIT_PATTERN, toWesternDigit)
    .replace(ARABIC_THOUSANDS_SEPARATOR_PATTERN, ",")
    .replace(ARABIC_DECIMAL_SEPARATOR_PATTERN, ".");
